<template>
  <div>
    <div>
      <el-form
        ref="form"
        :model="form"
        label-position="left"
        label-width="70px"
        size="mini"
      >
        <el-form-item label="时间：">
          <el-date-picker
            v-model="form.dateValue"
            type="datetimerange"
            align="right"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <div v-for="(item, index) of form.condidions" :key="item.seq">
          <el-form-item :label="`条件` + (index + 1) + `：`">
            <el-select v-model="item.condition" placeholder="请选择条件">
              <el-option
                v-for="conitionItem in avaiableConditions"
                :key="conitionItem.value"
                :label="conitionItem.label"
                :value="conitionItem.value"
              ></el-option>
            </el-select>
            =
            <el-select
              v-if="getInputTypeByCondition(item.condition) == 'select'"
              filterable
              v-model="item.value"
              placeholder="请选择值"
            >
              <el-option
                v-for="value in getValuesByCondition(item.condition)"
                :key="value.value"
                :label="value.label"
                :value="value.value"
              ></el-option>
            </el-select>
            <el-input
              v-else
              v-model="item.value"
              style="width: 200px"
            ></el-input>
            <el-button
              @click="onClickRemoveConditionBtn(index)"
              style="margin-left: 10px"
              icon="el-icon-delete"
              circle
            ></el-button>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button @click="addCondition()" class="el-icon-plus"
            >添加条件</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="onClickQueryBtn()"
            style="margin-left: 10px"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <el-table
      :data="list"
      border
      size="small"
      style="width: 1451px; margin-top: 10px"
      height="650px"
      v-el-table-infinite-scroll="loadMore"
      :infinite-scroll-disabled="list.length == 0"
    >
      <el-table-column
        prop="finishedAt"
        label="支付时间"
        align="center"
        width="140"
      >
        <template slot-scope="scope">
          <span>{{ ms2datetime(Number(scope.row.finishedAt)) }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="createdAt"
        label="下单时间"
        align="center"
        width="140"
      >
        <template slot-scope="scope">
          <span>{{ ms2datetime(Number(scope.row.createdAt)) }}</span>
        </template>
      </el-table-column> -->
      <el-table-column prop="type" label="订单类型" align="center" width="100">
      </el-table-column>
      <el-table-column prop="channel" label="渠道" align="center" width="100">
      </el-table-column>
      <el-table-column prop="zoneId" label="分区" align="center" width="50">
      </el-table-column>
      <el-table-column prop="aid" label="AID" align="center" width="80">
        <template slot-scope="scope">
          <span>
            <a
              href="javascript:;"
              style="text-decoration: none"
              @click="toRouterPlayerInfoPage('aid', scope.row.aid)"
            >
              {{ scope.row.aid }}</a
            ></span
          >
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="UID" align="center" width="80">
        <template slot-scope="scope">
          <span>
            <a
              href="javascript:;"
              style="text-decoration: none"
              @click="toRouterPlayerInfoPage('uid', scope.row.uid)"
            >
              {{ scope.row.uid }}</a
            ></span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="playerName"
        label="玩家昵称"
        align="center"
        width="120"
      >
      </el-table-column>

      <el-table-column
        prop="productName"
        label="商品"
        align="center"
        width="200"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="productId"
        label="商品ID"
        align="center"
        width="100"
      >
      </el-table-column>
      <el-table-column
        prop="price"
        label="价格（元）"
        align="center"
        width="100"
      >
      </el-table-column>

      <el-table-column prop="oS" label="操作系统" align="center" width="100">
      </el-table-column>
      <el-table-column
        prop="gameVersion"
        label="游戏版本"
        align="center"
        width="80"
      >
      </el-table-column>

      <el-table-column
        prop="id"
        label="订单ID"
        align="center"
        width="100"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="sdkOrderId"
        label="第三方订单ID"
        align="center"
        width="100"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().setHours(0, 0, 0, 0));
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date(new Date().setHours(0, 0, 0, 0));
              const start = new Date(end.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      list: [], //
      form: {
        condidions: [],
        dateValue: [],
      },
      avaiableConditions: [
        {
          value: "uid",
          label: "UID",
        },
        {
          value: "aid",
          label: "AID",
        },
        {
          value: "id",
          label: "订单ID",
        },
        {
          value: "sdk_order_id",
          label: "第三方订单id",
        },
        {
          value: "product_name",
          label: "商品",
        },
        {
          value: "product_id",
          label: "商品ID",
        },
        {
          value: "os",
          label: "操作系统",
        },
        {
          value: "type",
          label: "订单类型",
        },
        {
          value: "game_version",
          label: "游戏版本",
        },
      ], // 可用的条件
      nameList: [], // 资产名称集合
      osList: [], // 系统集合
      gameVersionList: [], // 版本集合
      typeList: [], // 订单类型集合
    };
  },

  async created(e) {
    this.loadConditions();
    this.form.dateValue = [
      new Date(new Date().setHours(0, 0, 0, 0)),
      new Date(new Date().setHours(0, 0, 0, 0) + 3600 * 1000 * 24),
    ];
    await this.loadList(0, 10);
  },

  components: {},

  methods: {
    loadMore() {
      this.loadList(this.list.length, 10);
    },
    ms2datetime(ts) {
      return util.ms2datetime(ts);
    },
    /**
     * 查询集合
     */
    async loadList(skip, limit) {
      if (skip == 0) {
        this.list = [];
      }

      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getLimitOrdersByCondition`,
          {
            skip: skip,
            limit: limit,
            startAt: this.form.dateValue[0].getTime(),
            endAt: this.form.dateValue[1].getTime(),
            conditions: this.form.condidions,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.list || [];

      this.list = this.list.concat(listInResponse);
    },
    addCondition() {
      this.form.condidions.push({
        condition: "",
        value: "",
      });
    },
    onClickRemoveConditionBtn(index) {
      this.form.condidions.splice(index, 1);
    },
    /**
     * 点击查询按钮
     */
    async onClickQueryBtn() {
      await this.loadList(0, 30);
    },

    /**
     * 查询订单中的条件集合
     */
    async loadConditions() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getOrderCondition`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      this.nameList = resData.data.names || [];
      this.osList = resData.data.os || [];
      this.gameVersionList = resData.data.gameVersion || [];
      this.typeList = resData.data.types || [];
    },

    /**
     * 根据条件得到结果集合
     * @param {*} condition
     */
    getValuesByCondition(condition) {
      switch (condition) {
        case "product_name": {
          return this.nameList;
        }
        case "os": {
          return this.osList;
        }
        case "game_version": {
          return this.gameVersionList;
        }
        case "type": {
          return this.typeList;
        }
        default: {
          return null;
        }
      }
    },
    /**
     * 根据条件得到输入框类型
     * @param {*} condition
     */
    getInputTypeByCondition(condition) {
      switch (condition) {
        case "product_name": {
        }
        case "os": {
        }
        case "type": {
        }
        case "game_version": {
          return "select";
        }
      }
    },

    /**
     * 跳转到玩家详情界面
     * @param {*}
     */
    toRouterPlayerInfoPage(condition, value) {
      let query = {};
      switch (condition) {
        case "uid": {
          query = { uid: value, tab: "playerList" };
          break;
        }
        case "aid": {
          query = { aid: value, tab: "playerList" };
          break;
        }
      }

      window.open(
        this.$router.resolve({
          path: "/console/player/playerlist",
          query: query,
        }).href,
        "_blank"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-table__row td {
  padding: 0px 0;
}
</style>